<template>
  <div v-if="computedValues.render" class="block-quote" :class="data.variant">
    <AppIcon
      v-if="data.variant !== 'is-no-box'"
      icon="snake"
      class="block-quote__icon"
      :is-raw="true"
    />
    <div
      v-if="computedValues.title && data.variant !== 'is-no-box'"
      class="block-quote__title"
    >
      {{ computedValues.title }}
    </div>
    <AtomRichtext
      v-if="computedValues.text"
      :data="computedValues.text"
      class="block-quote__text"
    />
    <div
      v-if="data.author && data.variant === 'is-no-box'"
      class="block-quote__author"
    >
      <p>{{ computedValues.author }}</p>
    </div>
    <div
      v-if="computedValues?.author"
      class="block-quote__author"
    >
      <AtomImage
        v-if="computedValues.authorImage"
        :src="computedValues.authorImage"
      />
      <p>{{ computedValues.author }}</p>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});

/*
    Get strapi data
*/
const storyStore = useStoryStore();
const strapiData = computed(() => {
    if (props.data?.strapi_data_key) {
        const data = storyStore.getConnectedStrapiValue(
            props.data?.strapi_data_key,
        );

        let quoteAuthor = null;

        if (props.data?.strapi_data_key_author) {
            quoteAuthor = storyStore.getConnectedStrapiValue(
                props.data?.strapi_data_key_author,
            );
        }

        if (data) {
            return {
                data,
                quoteAuthor,
            };
        }
    }

    return null;
});

/*
    Final data
*/
const computedValues = computed(() => {
    const strapiText = {
        strapi_data_key: props?.data?.strapi_data_key,
    };

    const data = {
        title: props.data?.strapi_data_key ? ''
            : props.data?.title,
        text: props.data?.strapi_data_key ? strapiText
            : props.data,
        author: props.data?.strapi_data_key_author ? strapiData?.value?.quoteAuthor?.name
            : props.data?.author,
        authorImage: props.data?.strapi_data_key_author ? strapiData?.value?.quoteAuthor?.image?.url
            : props.data?.authorImage,
        render: props.data?.strapi_data_key ? strapiData?.value?.data
            : props.data?.text?.content[0]?.content,
    };

    return data;
});

</script>

<style lang="scss">
.block-quote {
    @include component-spacing(30px, 60px);
    @include fluid('padding-top', 20px, 56px);
    @include fluid('padding-bottom', 20px, 56px);
    @include fluid('padding-left', 20px, 53px);
    @include fluid('padding-right', 20px, 53px);
    @include grid-columns(3, 10);

    @include tablet {
        @include grid-columns(2, 10);
    }

    border-radius: 12px;
    background-color: $C_GREEN_LIGHT;
    color: $C_GREEN_DARK;

    & + .atom-heading {
        @include fluid('margin-top', 30px, 60px);
    }
}

.block-quote__icon {
    @include fluid('margin-bottom', 30px, 51px);

    width: 80px;
}

.block-quote__title {
    @include typo-font('bold');
    @include fluid('font-size', 15px, 16px);

    margin-bottom: 19px;
}

.block-quote__text {
    margin-bottom: 29px;

    p {
        @include typo-font('italic');
        @include typo-size('quote');

        line-height: 1.2;
    }

    ul {
        position: relative;
        padding-left: 0;
        margin-left: 0;
        list-style-type: none;
    }

    li {
        @include fluid('padding-left', 30px, 51px);

        margin-bottom: 0;

        // creates a bigger bullet point
        &::before {
            @include fluid('font-size', 12px, 16px);

            position: absolute;
            top: 50%;
            height: auto;
            background-color: transparent;
            color: currentColor;
            content: '● ';
            transform: translateY(-50%);
        }
    }
}

.is-no-box {
    @include grid-columns(5, 10);

    padding: 0;
    background-color: transparent;
    color: $C_BLACK;

    .block-quote__icon {
        display: none;
    }

    .block-quote__text {
        margin-bottom: 10px;
    }

    @include tablet {
        @include grid-columns(2, 10);
    }
}

.block-quote__author {
    @include typo-font('regular');
    @include typo-size('a');

    display: flex;
    align-items: center;
    color: $C_GREEN_DARK;

    .atom-image {
        width: 100px;
        height: 100px;
        margin-right: 21px;

        img {
            border-radius: 50%;
        }
    }
}

</style>
